export default "__VITE_ASSET__BP13TTLh__"